<template>
  <div class="subAccountSetting_main"  :class="{'cn':version == '1','ja':version == '2'}">
    <div class="cont_left">
      <div class="text p1">{{ $t('App.subAccountSetting.text1') }}</div>
      <div class="form_box">
        <el-input class="input1"  v-model="formUser.username2" :placeholder="$t('App.subAccountSetting.text2')">
          <img class="icon" v-if="themeType == 0" slot="prefix" src="../img/login/login_2.png" />
          <img class="icon" v-if="themeType == 1" slot="prefix" src="../img/orange/login_1.png"/>
          <img class="icon" v-if="themeType == 2" slot="prefix" src="../img/grey/login_1.png"/>
        </el-input>
        <el-input class="input1" show-password v-model="formUser.password" :placeholder="$t('App.subAccountSetting.text3')">
          <img class="icon" v-if="themeType == 0" slot="prefix" src="../img/login/login_3.png" />
          <img class="icon" v-if="themeType == 1" slot="prefix" src="../img/orange/login_3.png" />
          <img class="icon" v-if="themeType == 2" slot="prefix" src="../img/grey/login_3.png" />
        </el-input>
        <el-input class="input1" show-password v-model="formUser.confirmPassword" :placeholder="$t('App.subAccountSetting.text4')">
          <img class="icon" v-if="themeType == 0" slot="prefix" src="../img/login/login_4.png" />
          <img class="icon" v-if="themeType == 1" slot="prefix" src="../img/orange/login_4.png" />
          <img class="icon" v-if="themeType == 2" slot="prefix" src="../img/grey/login_4.png" />
        </el-input>
        <el-input class="input1" v-model="formUser.email" :placeholder="$t('App.email')">
          <img class="icon0" v-if="themeType == 0" style="margin-top: 0.2rem; width: 1.85rem; opacity: 0.85;" slot="prefix" src="../img/login/email.png" />
          <img class="icon0" v-if="themeType == 1" style="margin-top: 0.2rem; width: 1.85rem; opacity: 0.85;" slot="prefix" src="../img/orange/email.png" />
          <img class="icon0" v-if="themeType == 2" style="margin-top: 0.2rem; width: 1.85rem; opacity: 0.85;" slot="prefix" src="../img/grey/email.png" />
        </el-input>
        
        <div class="select_lm margin_b" v-if="formUser.type != 3" :class="projectSelectShow ? 'select' : ''">
          <div class="val_box" @click="projectSelectFun" style="border-radius: 0.44rem; justify-content:flex-start">
            <img class="icon" v-if="themeType == 0" slot="prefix" src="../img/icon/icon6.png" />
            <img class="icon" v-if="themeType == 1" slot="prefix" src="../img/orange/icon6.png" />
            <img class="icon" v-if="themeType == 2" slot="prefix" src="../img/grey/icon6.png" />
            <div class="val0" v-if="!formUser.projectName">{{ $t('App.text15') }}</div>
            <div class="val" style="margin-left: 1rem;" :title="formUser.projectName">{{ formUser.projectName }}</div>
            <div class="icon_x"></div>
          </div>
          <div class="select_xl_lm_bg" v-if="projectSelectShow" @click="projectSelectFun"></div>
          <div class="select_xl_lm" v-if="projectSelectShow">
            <div class="icon"></div>
            <div class="ul scrollbar_style">
              <div class="li" :class="formUser.projectId == item.id ? 'select' : ''" v-for="(item, index) in provinceNavList" :key="index" @click="provinceItemClick(item)">
                <span class="text">{{ item.name }}</span>
              </div>
            </div>
          </div>
        </div>
        <el-select class="input1" v-model="formUser.type" :placeholder="$t('App.subAccountSetting.text5')" popper-class="select_popper">
          <span class="span" slot="prefix">ID</span>
          <el-option
            v-for="item in ldentityOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
        <div class="btn_box">
          <div class="btn1" @click="pageTypeFun">{{$t('App.cancel')}}</div>
          <div class="btn2"  @click="addUser()">{{$t('App.ok')}}</div>
        </div>
      </div>
    </div>
    
    <div class="cont_right">
      <div class="text p1">{{ $t('App.subAccountSetting.text6') }}</div>
      <div class="list_box  scrollbar_style">
        <div class="tr">
          <div class="th" style="width: 20rem;">{{ $t('App.subAccountSetting.text7') }}</div>
          <div class="th" style="width: 18rem;">{{ $t('App.subAccountSetting.text8') }}</div>
          <div class="th" style="width: 30rem;">{{ $t('App.email') }}</div>
          <div class="th" style="width: 10rem;">{{ $t('App.subAccountSetting.text9') }}</div>
        </div>
        <div class="tr" v-for="item in userList" :key="item.id" @click="dialogShowedit(item)">
          <div class="td" style="width: 20rem;">{{ item.username ? item.username : '-' }}</div>
          <div class="td" style="width: 18rem;">
            <div v-if="item.type=='0'">{{ $t('App.text8') }}</div>
            <div v-if="item.type=='1'">{{ $t('App.text9') }}</div>
            <div v-if="item.type=='2'">{{ $t('App.text10') }}</div>
            <div v-if="item.type=='3'">{{ $t('App.text16') }}</div>
            <!-- {{ item.type ? item.type : '-' }}</div> -->
          </div>  
          <div class="td" style="width: 30rem;" :title="item.email" >{{ item.email ? item.email : '-' }}</div>
          <div class="td" style="width: 10rem;"></div>
          <!-- <div class="td">
            <div class="btn" @click="accountDel()" v-loading="loading.accountDelLoading">{{ $t('App.delete') }}</div>
          </div> -->
        </div>
      </div>
    </div>
    <div class="dialog_box" v-if="dialogShow">
      <div class="bg"></div>
      <div class="form_box" ref="formUseredit" :model="formUseredit">
          <el-input class="input1" prop="username2" v-model="formUseredit.username2" :placeholder="$t('App.subAccountSetting.text2')">
            <img class="icon" v-if="themeType == 0" slot="prefix" src="../img/login/login_2.png" />
          <img class="icon" v-if="themeType == 1" slot="prefix" src="../img/orange/login_1.png"/>
          <img class="icon" v-if="themeType == 2" slot="prefix" src="../img/grey/login_1.png"/>
          </el-input>
          <el-input class="input1" show-password  prop="password" v-model="formUseredit.password" :placeholder="$t('App.subAccountSetting.text3')">
            <img class="icon" v-if="themeType == 0" slot="prefix" src="../img/login/login_3.png" />
            <img class="icon" v-if="themeType == 1" slot="prefix" src="../img/orange/login_3.png" />
            <img class="icon" v-if="themeType == 2" slot="prefix" src="../img/grey/login_3.png" />
          </el-input>
          <el-input class="input1" show-password  prop="confirmPassword" v-model="formUseredit.confirmPassword" :placeholder="$t('App.subAccountSetting.text3')">
            <img class="icon" v-if="themeType == 0" slot="prefix" src="../img/login/login_4.png" />
            <img class="icon" v-if="themeType == 1" slot="prefix" src="../img/orange/login_4.png" />
            <img class="icon" v-if="themeType == 2" slot="prefix" src="../img/grey/login_4.png" />
          </el-input>
          <el-input class="input1" v-model="formUseredit.email"  :placeholder="$t('App.email')">
            <img class="icon0" v-if="themeType == 0" style="margin-top: 0.2rem; width: 1.85rem; opacity: 0.85;" slot="prefix" src="../img/login/email.png" />
            <img class="icon0" v-if="themeType == 1" style="margin-top: 0.2rem; width: 1.85rem; opacity: 0.85;" slot="prefix" src="../img/orange/email.png" />
            <img class="icon0" v-if="themeType == 2" style="margin-top: 0.2rem; width: 1.85rem; opacity: 0.85;" slot="prefix" src="../img/grey/email.png" />
          </el-input>

        <!-- <el-select class="input1" prop="type"  v-model="formUseredit.type" :placeholder="$t('App.subAccountSetting.text5')" popper-class="select_popper">
          <span class="span" slot="prefix">ID</span>
          <el-option
            v-for="item in ldentityOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select> -->
        
        <div class="btn_box">
          <div class="btn3" @click="accountDel()" v-loading="loading.accountDelLoading">{{ $t('App.delete') }}</div>
          <div class="btn1" @click="dialogShow = false">{{$t('App.cancel')}}</div>
          <div class="btn2" @click="editUser()">{{$t('App.ok')}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
  import { mapGetters } from 'vuex'
  import allUrl from '../api/allUrl.js'
  import base from '../api/base.js'
  export default {
      name:'subAccountSetting',
      data () {
          return{
            formUser:{
              username2: '',
              password:'',
              confirmPassword: '',
              // avatarFile: '',
              type: '',
              projectName:'',
              projectId:'',
            },
            ldentityOptions:[],
            dialogShow:false,
            projectSelectShow:false,
            
            formUseredit:{
              id :'',
              username2: '',
              password: '',
              confirmPassword: '',
              // type: '',
              email:'',
            },
            subAccountSettingArr:[],
            userList: [],
            
            loading: {
              userAdd: false,
              useredit: false,
              accountDelLoading: false,
            },
          }
      },
      computed:{
          ...mapGetters({
              token:'token',
              client_key:'client_key',
              username:'username',
              version:'version',
              role:'role',

              projectId: 'projectId',

              remRatio:'remRatio',
              updateRemRatio:'updateRemRatio',

              countryId:'countryId',
              provinceId:'provinceId',
              cityId:'cityId',
              hotelId:'hotelId',
              headerIdStr:'headerIdStr',
              themeType: 'themeType',
          }),
          // sensorFormModelName(){
          //     let name = '';
          //     for(let d of this.modelNav){
          //         if(d.id == this.sensorForm.model){
          //             name = d.name
          //         }
          //     }
          //     return name
          // }
      },
      components:{
          // 'sideBar':sideBar
      },
      beforeDestroy(){
      },
      mounted(){
        this.userListGet();
        this.projectNavList();
        if(this.role == 0){
          this.ldentityOptions = [
            {id:'3',name:this.$t('App.text16')},
            {id:'1',name:this.$t('App.text9')},
            {id:'2',name:this.$t('App.text10')},
          ];
        }
        if(this.role == 1){
          this.ldentityOptions = [
            // {id:'1',name:this.$t('App.text9')},
            {id:'2',name:this.$t('App.text10')},
          ];
        }
        if(this.role == 3){
          this.ldentityOptions = [
            {id:'1',name:this.$t('App.text9')},
            {id:'2',name:this.$t('App.text10')},
          ];
        }
      },
      methods:{
        skinClassFun(){
          let obj = {};
          obj['cn'] = this.version == '1';
          // obj['ratio_1920_1080'] = this.ratio == '1';
          if(this.themeType == 1){
            obj['themeType_' + 1] = true;
          }
          // obj['themeType_' + 1] = true;
          return obj
        },
          // linkToFun(val,data){
          // }
        projectNavList() {
          base.ajax_post(
            allUrl.project.project_nav,
            {
              username: this.username,
              version: this.version,
              token: this.token,
            },
            {},
            (data) => {
                this.provinceNavList = data.data;
            },
            this
          );
        },
        projectSelectFun() {
          if (this.projectSelectShow) {
            this.projectSelectShow = false;
          } else {
            this.projectSelectShow = true;
          }
        },
        provinceItemClick(data) {
          this.formUser.projectId = data.id;
          this.formUser.projectName = data.name;
        },
        accountDel(){
          this.$confirm(
              this.$t('App.message.text3'), this.$t('App.message.text4'), {
                  confirmButtonText: this.$t('App.message.text5'),
                  cancelButtonText: this.$t('App.message.text6'),
                  type: 'warning'
              }
          ).then(() => {
            this.loading.accountDelLoading = true;
            base.ajax_post(
                allUrl.user.user_del,
                {
                  client_key:this.client_key,
                  token:this.token,
                  userId:this.formUseredit.id,
                  username: this.username,
                },
                {},
                data =>{
                  this.dialogAccount = false;
                  this.$message({
                      showClose: true,
                      message: data.msg,
                      type: 'success'
                  });
                  this.loading.accountDelLoading = false;
                  this.dialogShow = false
                  this.userListGet();
                },
              this,()=>{
                this.loading.accountDelLoading = false;
              })
          }).catch(() => {
              this.$message({
                  type: 'info',
                  message: this.$t('App.message.text7')
              });
              this.dialogShow = false    
          });
        },
        // 用户列表
        userListGet() {
          base.ajax_post(
            allUrl.user.user_list,
            {
              username: this.username,
              version: this.version,
              token: this.token,
              clientType: this.os,

              projectId: this.projectId,
            },
            {},
            data => {
              this.userList = data.data;
              console.log(data.data,'-----555---')
              console.log(data.data[0].username,'-----556---')
            },
            this, () => { })
        },
        //添加用户
        addUser() {
          if(this.loading.userAdd){
            return
          }
          this.loading.userAdd = true;
          base.ajax_post(
            allUrl.user.user_add,
            {
              username: this.username,
              version: this.version,
              token: this.token,
              clientType: this.os,
              projectId: this.projectId,

              ...this.formUser
            },
            {},
            data => {
              this.$message({
                showClose: true,
                message: data.msg,
                type: 'success'
              });
              this.loading.userAdd = false;
              this.userListGet();

            },
            this,()=>{
              this.loading.userAdd = false;
              // this.userListGet();
            }
          )
        },
        //编辑用户
        editUser() {
          // this.dialogShow = false
          if(this.loading.useredit){
            return
          }
          this.loading.useredit = true;
          base.ajax_post(
            allUrl.user.user_updateSubUser,
            {
              username: this.username,
              version: this.version,
              token: this.token,
              clientType: this.os,
              // projectId: this.projectId,

              ...this.formUseredit
            },
            {},
            data => {
              this.$message({
                showClose: true,
                message: data.msg,
                type: 'success'
              });
              this.loading.useredit = false;
              this.userListGet();
              console.log(1121,'-----555---')

            },
            this,()=>{
              this.loading.useredit = false;
              // this.userListGet();
              // this.dialogShow = false
            }
          )
          this.dialogShow = false
          // this.userListGet();
          console.log(1111,'-----555---')
        },
        dialogShowedit(item){

          this.dialogShow = true;
          this.formUseredit.id = item.id 
          this.formUseredit.username2 = item.username
          this.formUseredit.password = ''
          this.formUseredit.confirmPassword = ''
        },
        pageTypeFun () {
          this.$emit('pageTypeFun', 'systemSetting')
        },
      },
      watch:{
        // updateRemRatio:function(){
        // }
        projectId: function () {
          this.userListGet();
        },
      }
  }
</script>

<style type="text/css" lang="less">
  .subAccountSetting_main{
    position: absolute;
    top: 5.78rem;
    left: 0;
    width: 100%;
    height: calc(100% - 5.78rem);
    min-height: 50rem;
    margin: 0 auto;
    overflow: hidden;
    // position: relative;
    display: flex;
    background: rgba(255, 255, 255, 0.85);
    padding: 4.39rem 4.39rem;
    &.ja{
      .cont_left{
        .form_box{
          .btn_box{
            .btn1{
              width: initial;
              padding: 0 0.5rem;
            }
          }
        }
      }
      .dialog_box{
        .form_box{
          width: 40rem;
          .btn_box{
            width: 70%;
            .btn1{
              width: initial;
              padding: 0 0.5rem;
            }
          }
        }
      }
    }
    .cont_left{
      width: 39.39rem;
      .p1{
        font-size: 1.8rem;
        font-family: Calibri;
        font-weight: normal;
        color: rgba(58, 99, 111, 1);
        .i{
          color: #FF0101;
        }
      }

      
      .form_box{
        margin-top: 1.78rem;
        width: 29.47rem;
        height: 40.39rem;
        background: rgba(255, 255, 255, 0.5);
        border-radius: 0.88rem;
        padding: 3.95rem 0 0 0;
        position: relative;
        .select_lm{
          margin: 0 auto 2.96rem;
          width: 24.41rem;
          .val_box{
            height: 3.09rem;
            line-height: 3.09rem;
            background-color: rgba(0,0,0,0);
            .icon {
              width: 1.64rem;
              height: 1.64rem;
              margin-left: 0.3rem;
              margin-top: 0.68rem;
            }
            .val0 {
              white-space:nowrap;
              font-family: Calibri;
              font-weight: 400;
              font-size: 1.35rem;
              // color: #B5B5B5;
              color: rgb(147 161 167); 
              margin-left: 1rem;
            }
            .icon_x{
              top: 0.8rem;
            }
          }
          .select_xl_lm{
            width: 24.41rem;
            top: 3.8rem;
          }
        }
        .input1 {
          margin: 0 0 1.05rem 2.5rem;
          width: 24.41rem;
          &.margin_b{
            margin-bottom: 4.5rem;
          }
          // width: 32.54rem;
          // height: 4.12rem;
          // border: 0.09rem solid #3A636F;
          // border-radius: 0.44rem;
          // margin: 2.02rem 0 0 3.77rem;
          .el-input__inner{
            padding-left: 3.42rem;
            width: 24.41rem;
            height: 3.09rem;
            line-height: 3.09rem;
            border: 0.09rem solid #3A636F;
            border-radius: 0.44rem;
            background-color: rgba(0,0,0,0);
            
            font-family: Calibri;
            font-weight: normal;
            color: #3A636F;
            font-size: 1.8rem;
          }
          .el-input__prefix{
            width: 1.64rem;
            height: 1.64rem;
            top: 0.80rem;
            left: 0.79rem;
            .icon{
              width: 100%;
            }
          }
          .el-input__suffix{
            height: 3.09rem;
            line-height: 3.09rem;
            right: 1.49rem;
          }
          .span{
            // margin-top: -0.2rem;
            font-size: 1.8rem;
            font-family: Calibri;
            font-weight: normal;
            color: #3A636F;
            position: relative;
            line-height: 1.5rem;
            // top: -0.2rem;
          }
          .el-input .el-select__caret{
            font-size: 1.8rem;
            color: rgba(58, 99, 111, 1);
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
        
        .btn_box{
          position: absolute;
          bottom: 0rem;
          display: flex;
          align-items: center;
          justify-content: space-between;
          // margin-top: 1.75rem;
          margin: 0 0 3.29rem 3.09rem;
          width: 23.61rem;
          .btn1{
            width: 7.43rem;
            height: 3.13rem;
            line-height: 3.13rem;
            background: #F4FBFD;
            border: 0.09rem solid #3A636F;
            border-radius: 0.2rem;
            text-align: center;
            
            font-size: 1.8rem;
            font-family: Calibri;
            font-weight: normal;
            color: #3A636F;
            cursor: pointer;
            user-select: none;
          }
          .btn2{
            width: 7.43rem;
            height: 3.13rem;
            line-height: 3.13rem;
            background: #00C6FF;
            border: 0.09rem solid #00C6FF;
            border-radius: 0.2rem;
            text-align: center;

            font-size: 1.8rem;
            font-family: Calibri;
            font-weight: normal;
            color: #FFFFFF;
            cursor: pointer;
            user-select: none;
          }
          
        }
      }
    }
    
    .cont_right{
      flex: 1;
      margin-left: 6.32rem;
      .p1{
        font-size: 1.8rem;
        font-family: Calibri;
        font-weight: normal;
        color: #3A636F;
        .i{
          color: #FF0101;
        }
      }
      .list_box{
        margin-top: 2.3rem;
        width: 74.03rem;
        height: 40.26rem;
        background: rgba(255, 255, 255, 0.5);
        border-radius: 0.88rem;
        .tr{
          display: flex;
          align-items: center;
          border-bottom: 0.09rem solid #3A636F;
          
          .th,.td{
            // flex: 1;
            text-align: center;
            border-right: 0.09rem solid #3A636F;
            &:nth-child(4){
              border-right: none;
              // flex: none;
              // width: 10rem;
            }
          }
          .th{
            height: 2.37rem;
            line-height: 2.37rem;
            font-family: Calibri;
            font-weight: normal;
            font-size: 1.8rem;
            color: #3A636F;
            background: #E3F9FF;
          }
          .td{
            text-overflow: ellipsis;
            height: 3.07rem;
            line-height: 3.07rem;
            font-size: 1.8rem;
            font-family: Calibri;
            font-weight: normal;
            color: #3A636F;
            cursor: pointer;
            overflow: hidden;
            // display: flex;
            align-items: center;
            justify-content: center;
            white-space:nowrap;
          }
          .btn {
          text-align: center;
          width: 7.5rem;
          padding: 0 1rem;
          height: 2.5rem;
          line-height: 2.5rem;
          background: #F4FBFD;
          border-radius: 0.2rem;
          border: 0.1rem solid #3A636F;
         
          font-family: Calibri;
          font-weight: normal;
          font-size: 1.8rem;
          color: #3A636F;
          cursor: pointer;
        }
        }
      }
    }
    .dialog_box{
      position: fixed;
      top: 0;right: 0;left: 0;bottom: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      .bg{
        position: absolute;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0);
        z-index: -1;
      }
      .form_box{
        position: relative;
        width: 38.91rem;
        height: 38.88rem;
        background: rgba(244, 251, 253, 0.9);
        border-radius: 0.44rem;
        padding-top: 5rem;
        .input1 {
          margin: 0 auto 2.96rem;
          width: 27.5rem;
          display: block;
          &.margin_b{
            margin-bottom: 4.5rem;
          }
          // width: 32.54rem;
          // height: 4.12rem;
          // border: 0.09rem solid #3A636F;
          // border-radius: 0.44rem;
          // margin: 2.02rem 0 0 3.77rem;
          .el-input__inner{
            padding-left: 3.56rem;
            width: 27.5rem;
            height: 3.49rem;line-height: 3.49rem;
            border: 0.09rem solid #3A636F;
            border-radius: 0.44rem;
            background-color: rgba(0,0,0,0);
            
            font-size: 1.8rem;
            font-family: Calibri;
            font-weight: normal;
            color: #3A636F;
          }
          .el-input__prefix{
            width: 1.86rem;height: 1.86rem;
            top: 0.96rem;left: 0.79rem;
            .icon{
              width: 100%;
            }
          }
          .el-input__suffix{
            height: 4.12rem;line-height: 4.12rem;
            right: 1.49rem;
          }
          .span{
            margin-top: -0.2rem;
            font-size: 1.8rem;
            font-family: Calibri;
            font-weight: normal;
            color: #3A636F;
            position: relative;
            top: -0.2rem;
          }
          .el-input .el-select__caret{
            font-size: 1.8rem;
            color: rgba(58, 99, 111, 1);
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
        .btn_box{
          // position: absolute;
          // bottom: 0rem;
          display: flex;
          align-items: center;
          justify-content: space-between;
          // margin-top: 1.75rem;
          margin: 0 auto 3.29rem;
          width: 26.69rem;
          .btn1{
            width: 8.38rem;
            height: 3.53rem;
            line-height: 3.53rem;
            background: #F4FBFD;
            border: 0.09rem solid #3A636F;
            border-radius: 0.26rem;
            text-align: center;
            
            font-size: 1.8rem;
            font-family: Calibri;
            font-weight: normal;
            color: #3A636F;
            cursor: pointer;
            user-select: none;
          }
          .btn2{
            width: 8.38rem;
            height: 3.53rem;
            line-height: 3.53rem;
            background: #00C6FF;
            border: 0.09rem solid #00C6FF;
            border-radius: 0.26rem;
            text-align: center;

            font-size: 1.8rem;
            font-family: Calibri;
            font-weight: normal;
            color: #FFFFFF;
            cursor: pointer;
            user-select: none;
          }
          .btn3{
            width: 8.38rem;
            height: 3.53rem;
            line-height: 3.53rem;
            background: rgba(255, 0, 0, 1);
            border: 0.09rem solid rgba(255, 0, 0, 1);
            border-radius: 0.26rem;
            text-align: center;

            font-size: 1.8rem;
            font-family: Calibri;
            font-weight: normal;
            color: #FFFFFF;
            cursor: pointer;
            user-select: none;
          }
        }
      }
    }
  }
  // .subAccountSetting_main.themeType_1 {
  //   background: rgba(250,  237, 218, 0.9);
  //   .cont_left{
  //     .p1{
  //       color: #682411;
  //       .i{
  //         color: #FF0101;
  //       }
  //     }
  //     .form_box{
  //       margin-top: 1.78rem;
  //       width: 29.47rem;
  //       height: 40.39rem;
  //       background: rgba(242, 205, 155, 0.5);
  //       border-radius: 0.88rem;
  //       padding: 3.95rem 0 0 0;
  //       position: relative;
  //       .select_lm{
  //         margin: 0 auto 2.96rem;
  //         width: 24.41rem;
  //         .val_box{
  //           background: #faedda;
  //           border: 0.15rem solid #682411;
  //           .val {
  //             color: #682411;
  //           }
  //         }
  //         .select_xl_lm{
  //           width: 24.41rem;
  //           top: 3.8rem;
  //         }
  //       }
  //       .input1 {
  //         .el-input__inner{
  //           background: #faedda;
  //           border: 0.09rem solid #682411;
  //           color: #682411;
  //         }
  //         .span{
  //           color: #682411;
  //         }
  //         .el-input .el-select__caret{
  //           color: #682411;
  //         }
  //       }
        
  //       .btn_box .btn1{
  //         background: #f2cd9b;
  //         border: 0.09rem solid #682411;
  //         color: #682411;
  //       }
  //       .btn_box .btn2{
  //         background: #f44336;
  //         border: 0.09rem solid #f44336;
  //         color: #ffffff;
  //       }
  //     }
  //   }
    
  //   .cont_right{
  //     .p1{
  //       color: #682411;
  //       .i{
  //         color: #FF0101;
  //       }
  //     }
  //     .list_box{
  //       background: rgba(242, 205, 155, 0.5);
  //       .tr{
  //         border-bottom: 0.09rem solid #682411;
  //         .th,.td{
  //           border-right: 0.09rem solid #682411;
  //         }
  //         .th{
  //           color: #682411;
  //           background: #faedda;
  //         }
  //         .td{
  //           color: #682411;
  //         }
  //       }
  //     }
  //   }
  //   .dialog_box{
  //     .form_box{
  //       background: rgba(255, 251, 244, 0.9);
  //       // background: #FFFFFF;
  //       .input1 {
  //         .el-input__inner{
  //           border: 0.09rem solid #682411;
  //           background-color: rgba(0,0,0,0);
  //           color: #682411;
  //         }
  //         .span{
  //           color: #682411;
  //         }
  //         .el-input .el-select__caret{
  //           color: #682411;
  //         }
  //       }
  //       .btn_box{
  //         .btn1{
  //           background: #f2cd9b;
  //           border: 0.09rem solid #682411;
  //           color: #682411;
  //         }
  //         .btn2{
  //           background: #f44336;
  //           border: 0.09rem solid #f44336;
  //           color: #ffffff;
  //         }
  //       }
  //     }
  //   }
  //   .select_popper.el-select-dropdown {
  //     background: #faedda;
  //     border: 0.09rem solid #682411;
  //     border-radius: 0.44rem;
  //     .el-select-dropdown__item{
  //       &:hover {
  //         background: #fdbe6e;
  //       }
  //     }
     
  //   }
  //   .scrollbar_style::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
  //       border-radius: 0.5rem;
  //       // background: #DAE6E0;
  //       background: #682411;
  //   }
  //   .scrollbar_style::-webkit-scrollbar-track {/*滚动条里面轨道*/
  //       background: #faedda;
  //   }
  // }
</style>